$(function(){
	var calendar = $('#booking-calendar'),
		dayView = $('#booking-day-view'),
		close = dayView.find('.close'); 
	if(calendar.length){
		calendar.datepicker({
			minDate:0,
			maxDate:"+12m",
			firstDay:1,
			onSelect:daySelect,
			beforeShowDay: function(date){
		        if(blockedDates != 'undefined'){
		        	var dateString = jQuery.datepicker.formatDate('dd-mm-yy', date);
		        	return [$.inArray(dateString, blockedDates) == -1];
		        } else{
		        	return;
		        }
		    },
			onChangeMonthYear:function(){
				dayView.hide()
			}
		});
	}
	close.click(function(){
		dayView.hide()
	});
	function daySelect(date, cal){
		GetSlots(date);
		$('#booking-date-selected').val(date);
		// setTimeout(function(){
		// 	var active = calendar.find('.ui-state-active'),
		// 		aOffset = active.offset().top;
		// 	dayView.show().css('margin-top',0);
		// 	dayView.css('margin-top',aOffset - dayView.offset().top + active.height());
		// 	dayView.attr('data-sel',active.parent().index());
		// },10);
	}
	// SWITCH BETWEEN JOURNEYS
	$('.switch-journey-active').click(function(){
		$(this).toggleClass('active');
	});
	// SLIDER ON PROGRESS BAR
	var progress = $('.booking-progress-steps'),
		$progress = progress.flickity({
		prevNextButtons:false,
		pageDots:false,
		contain:true,
		cellAlign:'left',
		draggable:false
	});
	$progress.flickity('select',progress.find('.active').index())
	// Increment Quantities
	// $('.inc-less,.inc-more').click(function(){
	// 	var input = $(this).siblings('input'),
	// 		inc = 1;
	// 	if($(this).hasClass('inc-less')){
	// 		inc = -1;
	// 	}
	// 	if($(this).hasClass('inc-less') && parseInt(input.val()) == 0){
	// 		inc = 0;
	// 	}
	// 	input.val(parseInt(input.val()) + inc);
	// });
	// FIX CONTINUE PANEL ON DESKTOP
	$(window).resize(function(){
		$('.booking-continue').each(function(){
			$(this).css({
				top:$(this).siblings('.booking-basket').outerHeight()
			})
		});
	}).resize();
	// ACTIVATE VOUCHER BUTTON IF AVAILABLE
	$('#basket-promo-input').on('keyup',function(){
		if($(this).val().length > 0){
			$('#basket-promo-submit').attr('disabled',false);
		} else{
			$('#basket-promo-submit').attr('disabled',true);
		}
	});
	$(".checkbox__wrapper .checkbox__box").on("click", function() {
		
		var checkboxWrapper = $(".checkbox__wrapper")

		if ($(checkboxWrapper).find("input").prop("checked")) {
			$(checkboxWrapper).find("input").prop("checked", "on");
		}
		$(checkboxWrapper).find(".checkbox__box").toggleClass("checked");
			
	})
});

function goToPage(url){
	window.location = url;
}